import React                   from 'react'
import { connect }             from 'react-redux'
import i18n from '../../../i18n';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Tooltip } from 'reactstrap';
import ReactHtmlParser from 'html-react-parser';
import Input from '../../forms/Input';
import Formsy from 'formsy-react';
import withBaseComponent from '../../withBaseComponent';
import {mapDispatchToProps} from "../../mapDispatchToProps";
import { trackingEvent } from "../layouts/GoogleAnalytics.js"

class TagItem extends withBaseComponent(React.Component) {
  constructor(props) {
    super(props);

    this.state = {
      currentType: null,
      isOpenTooltip: false
    };

    this.toggleModalTag = this.toggleModalTag.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  trackingEditTag() {
    trackingEvent("Tag", "編集")
    this.toggleModalTag('edit')
  }

  onSubmit(model) {
    if (this.hasError()) {
      this.showErrors(model, this.refs.form.updateInputsWithError)
      return
    }

    this.state.currentType === 'delete'
      ? this.props.userActions.deleteTag(model.id).then(res => {
          this.toggleModalTag()
          return res
        })
      : this.props.userActions.editTag({tag: model}).then(res => {
        this.toggleModalTag()
        return res
      })
  }

  toggleTooltip() {
    this.setState({
      isOpenTooltip: !this.state.isOpenTooltip
    });
  }

  toggleModalTag(type=null) {
    this.setState({
      currentType: type,
      canSubmit: type === 'delete' || !this.state.canSubmit
    });
    this.toggleModal()
  }

  render() {
    const tag = this.props.item
    if (!tag)
      return null

    const isDelete = this.state.currentType === 'delete'

    return (
      <tr>
        <td className="align-middle">{tag.name}</td>
        <td className="align-middle">{tag.used_number}</td>
        <td className="align-middle text-right">
          <button type="button" className="btn mfc-btn-gray small" onClick={() => {this.trackingEditTag()}} >{i18n.t("common.edit")}</button>
          <button id={`deleteTag${tag.id}`} type="button" className={`btn mfc-btn-gray small ${tag.used_number > 0 ? 'disable' : 'mfc-btn-danger'}`} onClick={() => {trackingEvent("Tag", "削除"); if(tag.used_number === 0) this.toggleModalTag('delete')}}>{i18n.t("common.delete")}</button>
          <Modal isOpen={this.state.isOpenModal} className={this.props.className} centered={true}>
            <Formsy onChange={this.showErrors} ref="form" onSubmit={(model) => this.onSubmit(model)} onValid={this.enableButton} onInvalid={this.disableButton}>
              <ModalHeader toggle={this.toggleModalTag}>
                {isDelete ? i18n.t('tag.title.delete') : i18n.t('tag.title.edit')}
              </ModalHeader>
              <ModalBody>
              {!isDelete ?
                <div className="form-group">
                  <label>{i18n.t('tag.form.name')}</label>
                  <Input name="name" id="frm-name"
                    placeholder={i18n.t('tag.form.name_placeholder')}
                    validations="maxLength:20"
                    validationError={i18n.t('validations.tags.name')}
                    required
                    isDefaultRequiredValue={false}
                    value={tag.name}
                    />
                </div> :
                <div className="form-group" style={{marginBottom: 0}}>
                  {i18n.t('tag.confirm.delete', {name: tag.name})}
                </div>
              }
              </ModalBody>
              <ModalFooter>
                <Input name="id"  value={tag.id} type="hidden" />
                <Button onClick={() => this.toggleModalTag()} className="btn mfc-btn-gray medium">{i18n.t('common.cancel')}</Button>
                <button className={`btn ${isDelete ? 'mfc-btn-red' : 'mfc-btn-blue medium'}`} type="submit">
                  {isDelete ? i18n.t('common.delete') : i18n.t('common.save')}
                </button>
              </ModalFooter>
            </Formsy>
          </Modal>
          {tag.used_number > 0 && <Tooltip placement="auto" isOpen={this.state.isOpenTooltip} target={`deleteTag${tag.id}`} toggle={() => this.toggleTooltip()}>
            {ReactHtmlParser(i18n.t('tag.message.delete_tooltip'))}
          </Tooltip>}
        </td>
      </tr>
    )
  }
}

function mapStateToProps(state) {
  return {
    globalErrors: state.global.get('errors') || null
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TagItem)
